import React from 'react';
import PleadingFace from 'openmoji/color/svg/1F97A.svg';
import SlightlySmilingFace from 'openmoji/color/svg/1F642.svg';
import SmilingFaceWithSmilingEyes from 'openmoji/color/svg/1F60A.svg';
import GrinningFace from 'openmoji/color/svg/1F600.svg';
import GrinningFaceWithBigEyes from 'openmoji/color/svg/1F603.svg';
import GrinningFaceWithSmilingEyes from 'openmoji/color/svg/1F604.svg';
import BeamingFaceWithSmilingEyes from 'openmoji/color/svg/1F601.svg';
import HuggingFace from 'openmoji/color/svg/1F917.svg';
import SmilingFaceWithHeartEyes from 'openmoji/color/svg/1F60D.svg';
import SmilingFaceWithHearts from 'openmoji/color/svg/1F970.svg';
import ThinkingFace from 'openmoji/color/svg/1F914.svg';
import ClappingHands from 'openmoji/color/svg/1F44F.svg';

export const EmojiMap = {
  'pleading-face': PleadingFace,
  'slightly-smiling-face': SlightlySmilingFace,
  'smiling-face-with-smiling-eyes': SmilingFaceWithSmilingEyes,
  'grinning-face': GrinningFace,
  'grinning-face-with-big-eyes': GrinningFaceWithBigEyes,
  'grinning-face-with-smiling-eyes': GrinningFaceWithSmilingEyes,
  'beaming-face-with-smiling-eyes': BeamingFaceWithSmilingEyes,
  'hugging-face': HuggingFace,
  'smiling-face-with-heart-eyes': SmilingFaceWithHeartEyes,
  'smiling-face-with-hearts': SmilingFaceWithHearts,
  'thinking-face': ThinkingFace,
  'clapping-hands': ClappingHands,
};

export type OpenMojiKey = keyof typeof EmojiMap;

interface IOpenMojiProps extends React.SVGAttributes<SVGElement> {
  name: OpenMojiKey;
}

const OpenMoji: React.FC<IOpenMojiProps> = ({ name, ...rest }): JSX.Element => {
  if (!(name in EmojiMap)) throw new Error(`OpenMoji ${name} does not exist.`);

  const Icon = EmojiMap[name];
  return <Icon {...rest} />;
};

export default OpenMoji;
